import Image from 'next/image';
import React from 'react';

type BenefitsCardsProps = {
  records: BenefitsCardDetails[];
};
const BenefitsCards: React.FC<BenefitsCardsProps> = (props) => {
  const { records } = props;
  return (
    <div className="flex flex-col items-center lg:flex-row lg:items-stretch justify-between mx-auto max-w-[1100px] gap-3">
      {records.map((record, index) => (
        <BenefitsCard key={index} {...record} />
      ))}
    </div>
  );
};
BenefitsCards.displayName = 'BenefitsCards';
export default BenefitsCards;

export const BenefitsCardsPageSectionWrapper: React.FC<{ children: React.ReactNode }> = (props) => {
  const { children } = props;
  return (
    <>
      <div className="h-auto lg:h-[200px] pb-[100px]">{children}</div>
      <div className="bg-pureWhite hidden lg:block h-[100px]" />
    </>
  );
};
BenefitsCardsPageSectionWrapper.displayName = 'BenefitsCardsPageSectionWrapper';

/************************************************************************************************
 * Helpers
 ************************************************************************************************/

type BenefitsCardDetails = {
  imageUrl: string;
  title: string;
  description: string;
};
const BenefitsCard: React.FC<BenefitsCardDetails> = React.memo((props) => {
  const { imageUrl, title, description } = props;
  return (
    <div className="rounded-lg max-w-[300px] flex flex-col items-center gap-2 bg-pureWhite text-black text-center py-6 px-4 shadow-2xl mb-6 md:mb-0">
      <div className="w-[80px] h-[80px] flex items-center">
        <Image width={80} height={80} src={imageUrl} alt={title} />
      </div>
      <p className="text-2xl font-bold">{title}</p>
      <p>{description}</p>
    </div>
  );
});
BenefitsCard.displayName = 'BenefitsCard';
